import { render, staticRenderFns } from "./DecodeTx.vue?vue&type=template&id=656afaf3"
import script from "./DecodeTx.vue?vue&type=script&lang=js"
export * from "./DecodeTx.vue?vue&type=script&lang=js"
import style0 from "./DecodeTx.vue?vue&type=style&index=0&id=656afaf3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports